import { BiSolidLock } from "react-icons/bi";

function AccordionHeader({ isOwned, name, border }) {
  return (
    <div className={`py-5 ${border}`}>
      <p className="flex gap-3">
        <span>
          {!isOwned && (
            <BiSolidLock className="text-3xl text-gray-color-primary" />
          )}
        </span>
        {name}
      </p>
    </div>
  );
}

export default AccordionHeader;
